import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  getChild,
  getRoot,
  getCard,
  getIntegrationTypes,
  getObjectTypes,
  getParentElements,
  getDisplayElements,
  getValidationScheme,
  getMapCenter,
  getMapZoom,
  getObjectTypesRequestStatus,
  getSelectedElementParams,
  getDisplayElementAndTelemetryRequestStatus,
  getObjectConnectedIdentifiers,
  getConnectedLinesCoordinates,
} from '@/store/selectors/installation'
import { setInstallationParams } from '@/store/actions/installation/params'
import {
  setTree,
  setNode,
  setPins,
  setSelectedElementParams,
  setRequestStatus,
} from '@/store/actions/installation'

import { requestVerifyElements } from '@/store/actions/installation/verifyObject'
import { requestCreateGeoZone } from '@/store/actions/installation/createGeoZone'
import { requestEditGeoZone } from '@/store/actions/installation/editGeoZone'
import { requestDeleteGeoZone } from '@/store/actions/installation/deleteGeoZone'
import { requestCreateProject } from '@/store/actions/installation/createProject'
import { requestEditProject } from '@/store/actions/installation/editProject'
import { requestDeleteProject } from '@/store/actions/installation/deleteProject'
import { requestGetCard, successGetCard } from '@/store/actions/installation/getCard'
import { requestCreateObject } from '@/store/actions/installation/createObject'
import { requestEditObject } from '@/store/actions/installation/editObject'
import { requestDeleteObject } from '@/store/actions/installation/deleteObject'
import { requestCreateIntegration } from '@/store/actions/installation/createIntegration'
import { requestDeleteIntegration } from '@/store/actions/installation/deleteIntegration'
import { requestEditIntegration } from '@/store/actions/installation/editIntegration'
import { requestGetIntegrationTypes } from '@/store/actions/installation/getAvalibleIntegrationTypes'
import { requestGetObjectTypes } from '@/store/actions/installation/getObjectTypes'
import { requestGetTenantParents } from '@/store/actions/installation/getTenantParrents'
import { requestGetScheme } from '@/store/actions/installation/getScheme'
import {
  eventsDownloadMultipleObjectProgress,
  requestDownloadMultipleObject
} from '@/store/actions/installation/downloadMultipleObject'
import { requestGetObjectValidationScheme } from '@/store/actions/installation/getObjectValidationScheme'
import { requestGetInstallationObjectPDFFile } from '@/store/actions/installation/exportObjectPDF'
import { requestDownloadMultipleObjectScheme } from '@/store/actions/installation/downloadScheme'
import { requestGetPinsAndZonesAndTelemetry, successGetPinsAndZonesAndTelemetry } from '@/store/actions/installation/getZonesAndPinsAndTelemetry'
import { requestDeleteProjectCustomField } from '@/store/actions/installation/deleteProjectCustomField'
import { requestGetObjectConnectedIdentifiers } from '@/store/actions/installation/getObjectConnectedIdentifiers'
import { requestGetConnectedLinesCoordinates } from '@/store/actions/installation/getConnectedLinesCoordinates'
import { requestGetRootElements } from '@/store/actions/installation/getRootElemenet'

import Component from './component'
import {
  getGlobalFilters,
  getGlobalLoading,
  getMapLayer,
  getPinnedNode,
  getUserApplications,
  getUserData,
  getToggleRussianBorders,
} from '@/store/selectors/appSettings'
import { setSelectedNode } from '@/store/actions/appSettings'
import { getZones } from '@/store/selectors/passportization'

const mapStateToProps = (state) => ({
  childs: getChild(state),
  roots: getRoot(state),
  card: getCard(state),
  integrationTypes: getIntegrationTypes(state),
  objectTypes: getObjectTypes(state),
  parentElements: getParentElements(state),
  displayElements: getDisplayElements(state),
  validationScheme: getValidationScheme(state),
  mapCenter: getMapCenter(state),
  mapZoom: getMapZoom(state),
  objectTypesRequestStatus: getObjectTypesRequestStatus(state),
  selectedElementParams: getSelectedElementParams(state),
  userApplications: getUserApplications(state),
  loggedInUser: getUserData(state),
  pinnedNode: getPinnedNode(state),
  globalLoading: getGlobalLoading(state),
  globalFilters: getGlobalFilters(state),
  displayElementAndTelemetryRequestStatus: getDisplayElementAndTelemetryRequestStatus(state),
  zones: getZones(state),
  objectConnectedIdentifiers: getObjectConnectedIdentifiers(state),
  connectedLinesCoordinates: getConnectedLinesCoordinates(state),
  mapLayer: getMapLayer(state),
  isRussianBorders: getToggleRussianBorders(state),
})

const mapDispatchToProps = (dispatch) => ({
  setInstallationParams: (payload) => dispatch(setInstallationParams(payload)),
  setTree: (payload) => dispatch(setTree(payload)),
  setNode: (payload) => dispatch(setNode(payload)),
  pinNode: (payload, withoutPinned) => dispatch(setSelectedNode(payload, withoutPinned)),
  setPins: (payload) => dispatch(setPins(payload)),
  requestGetCard: (payload) => dispatch(requestGetCard(payload)),
  setCard: (payload) => dispatch(successGetCard(payload)),
  requestGetIntegrationTypes: (payload) => dispatch(requestGetIntegrationTypes(payload)),
  requestGetObjectTypes: (payload) => dispatch(requestGetObjectTypes(payload)),
  requestGetRootElements: () => dispatch(requestGetRootElements()),

  requestCreateGeoZone: (payload) => dispatch(requestCreateGeoZone(payload)),
  requestEditGeoZone: (payload) => dispatch(requestEditGeoZone(payload)),
  requestDeleteGeoZone: (payload) => dispatch(requestDeleteGeoZone(payload)),

  requestCreateProject: (payload) => dispatch(requestCreateProject(payload)),
  requestEditProject: (payload) => dispatch(requestEditProject(payload)),
  requestDeleteProject: (payload) => dispatch(requestDeleteProject(payload)),
  requestDeleteProjectCustomField: (payload) => dispatch(requestDeleteProjectCustomField(payload)),

  requestCreateObject: (payload) => dispatch(requestCreateObject(payload)),
  requestEditObject: (payload) => dispatch(requestEditObject(payload)),
  requestDeleteObject: (payload) => dispatch(requestDeleteObject(payload)),

  requestCreateIntegration: (payload) => dispatch(requestCreateIntegration(payload)),
  requestDeleteIntegration: (payload) => dispatch(requestDeleteIntegration(payload)),
  requestEditIntegration: (payload) => dispatch(requestEditIntegration(payload)),
  requestGetTenantParents: (payload) => dispatch(requestGetTenantParents(payload)),
  requestGetScheme: (payload) => dispatch(requestGetScheme(payload)),
  requestDownloadMultipleObject: (payload) => dispatch(requestDownloadMultipleObject(payload)),
  requestDownloadMultipleObjectProgress: (payload) => dispatch(eventsDownloadMultipleObjectProgress(payload)),
  requestGetObjectValidationScheme: (payload) => dispatch(requestGetObjectValidationScheme(payload)),
  requestGetInstallationObjectPDFFile: (payload) => dispatch(requestGetInstallationObjectPDFFile(payload)),
  requestVerifyElements: (payload) => dispatch(requestVerifyElements(payload)),
  requestDownloadMultipleObjectScheme: (payload) => dispatch(requestDownloadMultipleObjectScheme(payload)),
  setSelectedElementParams: (payload) => dispatch(setSelectedElementParams(payload)),
  setRequestStatus: (payload) => dispatch(setRequestStatus(payload)),
  requestGetPinsAndZonesAndTelemetry: (payload) => dispatch(requestGetPinsAndZonesAndTelemetry(payload)),
  successGetPinsAndZonesAndTelemetry: (payload) => dispatch(successGetPinsAndZonesAndTelemetry(payload)),
  requestGetObjectConnectedIdentifiers: (payload) => dispatch(requestGetObjectConnectedIdentifiers(payload)),
  requestGetConnectedLinesCoordinates: (payload) => dispatch(requestGetConnectedLinesCoordinates(payload)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(Component))
